module.exports = __webpack_public_path__ + "img/image-6.6b72f22a.jpg";